export const collapseMaintitle = {
    // backgroundColor: "#DCDCDC",
    color: "#003755",
    // marginBottom: '10px',
    padding: '8px 5px 8px 5px',
    fontWeight: 700,
    cursor: 'pointer',
}

export const PeriodType = {
    fontSize: '16px',
    lineHeight: '1.275em',
    margin: '0 0 10px',
    color: '#003755',
}

export const timeType = {
    fontSize: '16px',
    lineHeight: '1.275em',
    margin: '0 0 10px',
    color: '#003755',
    padding: '0px 0px 0px 10px',
}

export const inputImgStyle = {
    // backgroundImage: "url('../../assets/icons/search_darkblue.svg')",
    backgroundPosition: 'right 10px center',
    backgroundRepeat: 'no-repeat',
    paddingRight: '30px',
};

export const followingAnalysts = {
    fontSize: '16px',
    lineHeight: '1.275em',
    margin: '0 0 8px',
    color: '#003755',
    padding: '0px 0px 0px 8px',
}

export const badgeFilter = {
    backgroundColor: 'white',
    border: "1px solid #2F4F4F",
    color: '#2F4F4F',
    padding: '5px 5px 5px 5px',
    marginTop: '5px',
    fontSize: '16px',
    '&:hover': {
        backgroundColor: 'white !important',
        color: '#2F4F4F !important',
    },
}

export const customHrTag = {
    marginLeft: '-10px',
    width: '300px',
    backdroundColor: '#DFEEF4',
    // marginTop: '0px',
    // marginBottom: '0px',
}